// extracted by mini-css-extract-plugin
module.exports = {"root":"Toolbar_root__9MtPO","input":"Toolbar_input__1UMC1"};